<template>
  <router-link :to="`/news/${data.id}`" class="news-block flex-row">
    <div class="news-cover">
      <img :src="data.cover_url" alt width="220" height="126" loading="lazy" />
    </div>
    <div class="news-info flex-col justify-between">
      <h2 v-text="data.topic"></h2>
      <div class="pubtime" v-text="data.publish_time"></div>
    </div>
  </router-link>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "NewsBlock",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },
  components: {},
  setup() {},
});
</script>
<style lang="scss" scoped>
.news-block {
  height: 126px;
  margin-bottom: 30px;
  transition: all 0.2s;
  &:hover {
    h2 {
      text-decoration: underline;
    }
  }
  .news-cover {
    width: 220px;
    height: 126px;
    border-radius: 5px;
    margin-right: 20px;
    object-fit: cover;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 5px;
    }
  }
  .news-info {
    height: 120px;
    h2 {
      height: 84px;
      font-size: 20px;
      font-weight: 600;
      color: #423e3d;
      line-height: 28px;
      overflow: hidden;
      width: 860px;
    }
    .pubtime {
      height: 18px;
      font-size: 12px;
      color: #b1a9a7;
      line-height: 18px;
    }
  }
}
</style>
